import PropTypes from 'prop-types'
import { Layout } from 'layout/layout'
import { AboutUsSection } from 'components/sections/aboutUs'
import { HowItWorksSection } from 'components/sections/howItWorks'
import { ContactUsSection } from 'components/sections/contactUs'
// import { ReviewsSection } from 'components/sections/reviews'
import { HeaderSection } from 'pages/landing/headerSection'
import { API, locationDealsPath } from 'app/apiService'

const LocationLanding = ({ deals, defaultClass }) => {
  return (
    <Layout defaultClass={defaultClass}>
      <HeaderSection deals={deals} defaultClass={defaultClass} />
      <HowItWorksSection />
      {/* <ReviewsSection /> */}
      <AboutUsSection />
      <ContactUsSection />
    </Layout>
  )
}

LocationLanding.propTypes = {
  deals: PropTypes.object,
  defaultClass: PropTypes.string,
}

export const getServerSideProps = async ({ query: { locationType, location, cabinClass } }) => {
  const deals = await API.get(locationDealsPath(locationType, location, cabinClass))
  if (deals?.price?.length === 0 || deals?.error) {
    return {
      notFound: true,
    }
  }
  return {
    props: {
      deals,
      defaultClass: cabinClass || 'economy',
    },
  }
}

export default LocationLanding
